import {Component, OnInit, ElementRef, ViewChild} from '@angular/core';
import {
  CATEGORIAS_WEB,
  FIND_PROMOTION_BY_COD_PROMOCION_SAM,
  GET_ALL_PROMOCIONES_WEB,
  UPDATE_PROMOCION_OF_DOCUMENT
} from '../../../graphql/graphql.queris';
import {Apollo} from "apollo-angular";
import {Router, RouterLink} from "@angular/router";
import {NgForOf, NgIf} from "@angular/common";
import {convertirPrimeraLetraMayuscula, capturarFile, closeModal} from "../../../utils/utilities";
import {environment} from "../../../../environments/environment";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {RestService} from "../../../services/rest.services.service";
import {DomSanitizer} from "@angular/platform-browser";
import moment from "moment";
import {AuthService} from "../../../auth/auth.service";
import {NotificationsComponent} from "../../../notifications/notifications.component";
import {ServiceNotificationService} from "../../../services/service-notification.service";
import {BreadcrumbMktComponent} from "../breadcrumb-mkt/breadcrumb-mkt.component";
import {of} from "rxjs";
declare var bootstrap: any;


@Component({
  selector: 'app-promociones-mkt-web',
  standalone: true,
    imports: [
        RouterLink,
        NgForOf,
        ReactiveFormsModule,
        NgIf,
        NotificationsComponent,
        BreadcrumbMktComponent
    ],
  templateUrl: './promociones-mkt-web.component.html',
  styleUrl: './promociones-mkt-web.component.css'
})
export class PromocionesMktWebComponent implements OnInit {
  @ViewChild('modalUpdatePromocion') modalUpdate!: ElementRef;
  @ViewChild('inputImagen') inputImagen!: ElementRef;
  promotionsWeb: any[] = [];
  title: string = 'Promociones Web';
  route= '/dashboardmkt/promocionesWeb'
  imgUrl = environment.imgUrl;
  formUpdatePromocion: FormGroup = new FormGroup({});
  nombre = '';
  tipoPromocion: string = '';
  descripcionPromocion: [] = [];
  descripcion: string = '';
  precio: number | undefined;
  preview: string | ArrayBuffer | null | undefined;
  fechaExpiracion: Date | undefined;
  disclaimer: string = '';
  imagenPromocion: string = '';
  public archivos: any = [];
  urlImage: string = '';
  _idPromocion: string  = '';
  categorias: any[] = [];
  servicios: { serv_nombre: string }[] = [];
  isLoading: Boolean = false;



  constructor(
    private apollo: Apollo,
    private fb: FormBuilder,
    private restService: RestService,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private serviceNotifications: ServiceNotificationService,
  ) {
  }

  ngOnInit() {
    this.getPromociones();
    this.getCategorias();

    this.formUpdatePromocion = this.fb.group({
      _id: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      tipoPromocion: ['', [Validators.required]],
      servicios: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      fechaExpiracion: ['2050-12-12', [Validators.required]],
      statusPromocion: ['', [Validators.required]],
      disclaimer: ['', [Validators.required]],
      codPromocionSam: [''],
      precio: [''],
      imagenPromocion: [''],
      isFeatured: [Validators.required]

    });


    this.formUpdatePromocion.get('isFeatured')?.valueChanges.subscribe(value => {
      const booleanValue = value === 'true';
      if (this.formUpdatePromocion.get('isFeatured')?.value !== booleanValue) {
        this.formUpdatePromocion.patchValue({isFeatured: booleanValue}, {emitEvent: false});
      }
    });
    this.formUpdatePromocion.get('statusPromocion')?.valueChanges.subscribe(value => {
      const booleanValue = value === 'true';
      if (this.formUpdatePromocion.get('statusPromocion')?.value !== booleanValue) {
        this.formUpdatePromocion.patchValue({statusPromocion: booleanValue}, {emitEvent: false});
      }
    });

  }

  getPromociones() {
    const token = this.authService.getToken();
    this.apollo
      .watchQuery({
        query: GET_ALL_PROMOCIONES_WEB,
        context: {
          headers: {
            Authorization: `Bearer ${token}`
          }
        },
        fetchPolicy: 'network-only'
      }).valueChanges.subscribe((result: any) => {

      if (result && result.data && result.data.getAllDataWebPrivate) {
        const categoriasConPromociones = result.data.getAllDataWebPrivate;
        this.promotionsWeb = categoriasConPromociones.flatMap((entity: { categoria: string; promociones: any[] }) =>
          entity.promociones.map((promotion: any) => ({
            ...promotion,
            categoria: entity.categoria
          }))
        );

        this.promotionsWeb = this.promotionsWeb.filter((promotion: any) => Object.keys(promotion).length > 0);
      } else {
        console.error('No se encontraron datos válidos en el resultado de la consulta.');
      }
    });
  }

  getCategorias() {
    this.authService.isTokenExpired();
    this.apollo.watchQuery({
      query: CATEGORIAS_WEB,
      context: {
        headers: {
          Authorization: `Bearer ${this.authService.getToken()}`
        }
      }
    }).valueChanges.subscribe((result: any) => {
      this.categorias = result.data.getAllDataWebPrivate;
    });
  }


  protected readonly convertirPrimeraLetraMayuscula = convertirPrimeraLetraMayuscula;

  getAllDataPromotion(codPromocionSam: number) {
    this.GET_DATA_PROMOTION(codPromocionSam);

  }

  onSubmit() {

  }


  capturarArchivo(event: Event): void {
    capturarFile(event, this.sanitizer, this.archivos, (preview)=> this.preview = preview);
  }




  GET_DATA_PROMOTION(codPromocionSam: number) {
    this.inputImagen.nativeElement.value = '';
    this.preview = '';
    const token = this.authService.getToken();
    this.apollo.query({
      query: FIND_PROMOTION_BY_COD_PROMOCION_SAM,
      variables: {codPromocionSam: codPromocionSam},
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      fetchPolicy: 'network-only'
    })
      .subscribe((result: any) => {
        const {
          codPromocionSam,
          descripcion,
          disclaimer,
          imagenPromocion,
          nombre,
          tipoPromocion,
          precio,
          fechaExpiracion,
          statusPromocion,
          servicios,
          isFeatured,
          _id
        } = result.data.findPromotionByCodPromocionSam;

        this.nombre = nombre;
        this.tipoPromocion = tipoPromocion;
        this.servicios = servicios;
        this.descripcion = descripcion;
        this.disclaimer = disclaimer;
        this.precio= precio;
        this.imagenPromocion = imagenPromocion;
        this.formUpdatePromocion.patchValue({
          _id: _id,
          codPromocionSam: codPromocionSam,
          nombre: this.nombre,
          servicios: this.servicios,
          tipoPromocion: this.tipoPromocion,
          descripcion: this.descripcion,
          disclaimer: this.disclaimer,
          precio: this.precio ,
          imagenUrl: this.imagenPromocion,
          statusPromocion: statusPromocion,
          isFeatured: isFeatured,
        })
      })
  }






  sendAllData() {
    if (this.formUpdatePromocion.invalid) {
      this.formUpdatePromocion.markAllAsTouched();
      this.mostrarToast('Asegúrate de que los datos en el formulario estén correctos', false);
      return;
    }
    this.isLoading = true;
    const datosPromocion = new FormData();
    this.archivos.forEach((archivo: any) => {
      datosPromocion.append('file', archivo);
    });

    const uploadImageObservable = this.archivos.length > 0
      ? this.restService.post({ url: environment.apiUploadImage, body: datosPromocion })
      : of({ path: this.imagenPromocion });

    uploadImageObservable.subscribe((res: any) => {
      this.urlImage = Array.isArray(res) ? res[0].path : res.path;
      this.formUpdatePromocion.patchValue({ imagenPromocion: this.urlImage });
      this.funcionUpdatePromocion(this.formUpdatePromocion.value._id, this.formUpdatePromocion.value.codPromocionSam, this.formUpdatePromocion.value);
    });

    this.getPromociones();
    this.archivos=[];
  }


  funcionUpdatePromocion(id: string, codPromocionSam: number ,input: any) {
    try {
      const token = this.authService.getToken();
      this.apollo.mutate({
        mutation: UPDATE_PROMOCION_OF_DOCUMENT,
        variables: {
          id: id,
          codPromocionSam: codPromocionSam,
          promotion: input
        },
        context: {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      }).subscribe((result: any) => {
        this.isLoading = false;
        this.formUpdatePromocion.reset();
        this.preview = '';
        this.imagenPromocion = '';
        this.formUpdatePromocion.patchValue({ fechaExpiracion: '2050-12-12' });
        this.archivos = [];
        this.getPromociones();
        this.mostrarToast('Promoción actualizada correctamente', true);
        closeModal(this.modalUpdate);


      })
    }catch (e) {
      console.error('Error al crear la promoción:', e);
      this.mostrarToast('Error al crear la promoción', false);
    }

  }




  protected readonly moment = moment;

  mostrarToast(message: string, type: boolean) {
    this.serviceNotifications.recibeNotificacion.emit({
      mensaje: message,
      tipo: type
    })
  }


}
